import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./StageProgress.css";

const Stage = ({ isPassed, label, onClick, period }) => (
  <div className={classnames(styles.stage, { [styles.passed]: isPassed })}>
    <button className={styles.btnStage} onClick={onClick}>
      <span className={styles.name}>{label}</span>
      <span className={styles.period}>{period}</span>
    </button>
  </div>
);

Stage.propTypes = {
  isPassed: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  period: PropTypes.number,
};

export default Stage;
